import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
} from '@mui/material';
import Seo from '../components/Seo';

const Terms = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Seo
        title="Terms of Service"
        description="The terms governing the use of InspectIQ Private Limited's services and website."
        path="/terms"
      />
      <Typography variant="h3" component="h1" gutterBottom align="center">
        Terms of Service
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" align="center" paragraph>
        Last updated: {new Date().toLocaleDateString()}
      </Typography>

      <Paper elevation={0} sx={{ p: 4, backgroundColor: 'background.paper' }}>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            1. Acceptance of Terms
          </Typography>
          <Typography paragraph>
            By accessing and using InspectIQ's services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using our services.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            2. Services Description
          </Typography>
          <Typography paragraph>
            InspectIQ provides quality inspection and assurance services, including but not limited to:
          </Typography>
          <Typography component="ul" sx={{ pl: 2 }}>
            <li>Draft Survey & Marine Services</li>
            <li>Loading & Pre-Shipment Inspection</li>
            <li>Quality & Quantity Inspection</li>
            <li>Tally for Chemical Goods</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            3. Client Responsibilities
          </Typography>
          <Typography paragraph>
            As a client, you agree to:
          </Typography>
          <Typography component="ul" sx={{ pl: 2 }}>
            <li>Provide accurate and complete information</li>
            <li>Maintain the confidentiality of your account</li>
            <li>Comply with all applicable laws and regulations</li>
            <li>Pay all fees and charges in a timely manner</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            4. Service Limitations
          </Typography>
          <Typography paragraph>
            Our services are subject to the following limitations:
          </Typography>
          <Typography component="ul" sx={{ pl: 2 }}>
            <li>Availability of qualified personnel</li>
            <li>Technical and operational constraints</li>
            <li>Force majeure events</li>
            <li>Regulatory requirements</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            5. Payment Terms
          </Typography>
          <Typography paragraph>
            Payment terms and conditions:
          </Typography>
          <Typography component="ul" sx={{ pl: 2 }}>
            <li>All fees are due within 30 days of invoice date</li>
            <li>Late payments may incur additional charges</li>
            <li>Prices are subject to change with notice</li>
            <li>All amounts are in the specified currency</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            6. Limitation of Liability
          </Typography>
          <Typography paragraph>
            InspectIQ shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h5" gutterBottom>
            7. Contact Information
          </Typography>
          <Typography paragraph>
            For any inquiries about these Terms of Service, please contact us at:
          </Typography>
          <Typography paragraph>
            Email: info@inspectiq.in<br />
            Phone: +91 95861 41990
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1 }}>
            Vadodara Office
          </Typography>
          <Typography>
            Third Floor - 1, Shree Siddheshwar Hallmark,<br />
            Nr, Ajwa Rd, Sayaji Park Society,<br />
            Vadodara, Gujarat 390019<br />
            India
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default Terms; 